import type { AdminOrdersListParams } from "@motolynk/api-client";

/** Tabs of the admin's order list ("stuck" = a store hasn't confirmed its part for a day). */
export const ADMIN_TABS = [
  "all",
  "stuck",
  "placed",
  "confirmed",
  "processing",
  "partially_shipped",
  "shipped",
  "completed",
  "partially_cancelled",
  "cancelled",
  "awaiting_payment",
] as const;
export type AdminTab = (typeof ADMIN_TABS)[number];

export const adminOrderKeys = {
  all: ["admin", "orders"] as const,
  list: (params: AdminOrdersListParams) => ["admin", "orders", "list", params] as const,
  counts: () => ["admin", "orders", "counts"] as const,
  detail: (number: string) => ["admin", "orders", "detail", number] as const,
  couriers: () => ["admin", "couriers"] as const,
};
